const VOICE_START_URL = '/sound/voice-start.m4a'
const VOICE_STOP_URL = '/sound/voice-stop.m4a'

/** Fire-and-forget cue; a blocked autoplay is ignored. */
function playCue(url: string): void {
  if (typeof Audio === 'undefined') return
  const audio = new Audio(url)
  audio.preload = 'auto'
  void audio.play().catch(() => undefined)
}

/** Played when voice dictation starts, so the user knows the mic is live. */
export function playVoiceStart(): void {
  playCue(VOICE_START_URL)
}

/** Played when voice dictation stops, confirming the mic is no longer listening. */
export function playVoiceStop(): void {
  playCue(VOICE_STOP_URL)
}
